import Vue from 'vue'
import VueRouter from 'vue-router'
import children from './children'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  ...children,
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js